angular.module('NaviaqWebApp').directive('activityLineText', [function () {
    'use strict';

    return {
        restrict: 'A',
        replace: true,
        templateUrl: 'app/report/directives/activity-line-text.html',
        link: function (scope, element, attrs) {
        }
    };
}]);
